export default __webpack_public_path__ + "static/img-asaas-823519c4c2f8b49b951a1ed737d03917.webp";